import { useState, useRef, useEffect } from "react";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav id="navbar" ref={menuRef}>
      <a href="#" className="nav-logo">
        <div className="nav-logo-mark">
          ARCH <span>&amp;</span> CROWN
        </div>
      </a>

      {/* Desktop Links */}
      <ul className="nav-links">
        <li><a href="#about">About</a></li>
        <li><a href="#events">Events</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#vendors">Vendors</a></li>
        <li><a href="#gallery">Gallery</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

<button
  className="nav-cta"
  onClick={() => {
    const message = encodeURIComponent(
      "Hi Arch & Crown Events! I’m interested in planning an event and would like to know more about your services."
    );

    window.open(`https://wa.me/917702254457?text=${message}`, "_blank");
  }}
>
  Plan Your Event
</button>
      {/* Hamburger */}
      <div 
        className={open ? "hamburger active" : "hamburger"} 
        onClick={() => setOpen(!open)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Dropdown */}
      <div className={open ? "mobile-dropdown show" : "mobile-dropdown"}>
        <a href="#about" onClick={() => setOpen(false)}>About</a>
        <a href="#events" onClick={() => setOpen(false)}>Events</a>
        <a href="#services" onClick={() => setOpen(false)}>Services</a>
        <a href="#vendors" onClick={() => setOpen(false)}>Vendors</a>
        <a href="#gallery" onClick={() => setOpen(false)}>Gallery</a>
        <a href="#contact" onClick={() => setOpen(false)}>Contact</a>
      </div>
    </nav>
  );
}